import { colors } from '@atlaskit/theme';
import type { BarChartDataPoint, DateRange } from '../../../common/types.tsx';
import { isDateRangeSame } from '../../../common/utils/date-range.tsx';
import type { BarChartData } from '../../../services/historical-cycle-time/types.tsx';

const getEmphasisColor = (
	cycleTimeStatistics: number,
	wholePeriodStatistics: number | null,
): string =>
	wholePeriodStatistics === null || cycleTimeStatistics <= wholePeriodStatistics
		? colors.G300
		: colors.Y400;

export const convertBarChartDataToChartDataPoints = (
	data: BarChartData,
	selectedDateRange: DateRange,
	isDataEmpty: boolean,
): BarChartDataPoint[] =>
	data.barData.map((x) => {
		const isSelectedData =
			!isDataEmpty &&
			isDateRangeSame(selectedDateRange, {
				startDateInclusive: x.startDateInclusive,
				endDateExclusive: x.endDateExclusive,
			});
		const emphasisColor = getEmphasisColor(
			x.cycleTimeStatistics ?? 0,
			data.hasEnoughDataForMeaningfulStatistics ? data.wholePeriodStatistics : null,
		);

		return {
			value: x.cycleTimeStatistics ?? 0,
			itemStyle: { color: isSelectedData ? emphasisColor : colors.N80 },
			customInfo: {
				startDateInclusive: x.startDateInclusive,
				endDateExclusive: x.endDateExclusive,
				numIssues: x.numIssues,
				emphasisColor: isSelectedData ? emphasisColor : null,
				tooltipFormatCycleTime: x.cycleTimeStatistics,
			},
			emphasis: {
				itemStyle: {
					color: emphasisColor,
				},
			},
		};
	});
